__webpack_require__.p = "https://beta.navigation.ui.usm.prime-video.amazon.dev/";